/*
 * @Author: Teemo Ding
 * @Date: 2021-08-25 16:32:49
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-13 11:02:31
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelPayment/BankTransferDetails/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Col, Form, Row } from 'antd';
import React from 'react';
import { Label, TextArea } from 'src/components/Antd';
import css from '../css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { paymentGatewayProvider } from '@/src/types/common/paymentGateway';

const BankTransferDetails = ({
  paymentProviderList,
  isPrimary,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.bankTransferDetails}
      title={getI18n('salesChannelPayment.index.availableMethods')}>
      {paymentProviderList.includes(paymentGatewayProvider.BANK_TRANSFER) && (
        <Row>
          <Col span={11}>
            <Form.Item
              name='bankTransferInstruction'
              rules={[
                {
                  required: true,
                  message: getI18n('general.pleasefillthisfield'),
                },
              ]}
              label={
                <Label
                  title={`${getI18n(
                    'salesChannelPayment.index.bankTransferInstruction',
                  )}*`}
                  textLength={1000}
                  nameKey='bankTransferInstruction'
                />
              }
              labelCol={{ span: 24 }}>
              <TextArea
                disabled={disableEdit}
                size='large'
                maxLength={1000}
                autoSize={{ minRows: 3, maxRows: 3 }}
              />
            </Form.Item>
          </Col>
          {isPrimary && (
            <Col span={11} offset={1}>
              <Form.Item
                label={getI18n(
                  'salesChannelPayment.index.bankTransferReference',
                )}
                labelCol={{ span: 24 }}>
                {getI18n('salesChannelPayment.index.orderID')}
              </Form.Item>
            </Col>
          )}
        </Row>
      )}
      {paymentProviderList.includes(paymentGatewayProvider.FPS_QR_CODE) && (
        <Row>
          <Col span={11}>
            <Form.Item
              name='fpsQrCodeInstruction'
              rules={[
                {
                  required: true,
                  message: getI18n('general.pleasefillthisfield'),
                },
              ]}
              label={
                <Label
                  title={`${getI18n(
                    'salesChannelPayment.index.fPSPaymentInstructions',
                  )}*`}
                  textLength={1000}
                  nameKey='fpsQrCodeInstruction'
                />
              }
              labelCol={{ span: 24 }}>
              <TextArea
                disabled={disableEdit}
                size='large'
                maxLength={1000}
                autoSize={{ minRows: 3, maxRows: 3 }}
              />
            </Form.Item>
          </Col>
          {isPrimary && (
            <Col span={11} offset={1}>
              <Form.Item
                label={getI18n('salesChannelPayment.index.fPSReference')}
                labelCol={{ span: 24 }}>
                {getI18n('salesChannelPayment.index.orderID')}
              </Form.Item>
            </Col>
          )}
        </Row>
      )}
    </SectionWrapper>
  );
};

export default BankTransferDetails;
